import type {
  DataAuditSourceMetaDataApi,
  DataAuditSourceMetaDataInput,
} from 'src/components/data-audit/types';


export const getDataAuditAutomationWorkflowUrl = (workflowId: string): string =>
  `/automation-workflow/${workflowId}`;

const parseDataAuditSourceMetaData = (
  sourceMetaData: DataAuditSourceMetaDataInput,
): DataAuditSourceMetaDataApi | null => {
  if (!sourceMetaData) {
    return null;
  }

  if (typeof sourceMetaData === 'string') {
    try {
      return JSON.parse(sourceMetaData) as DataAuditSourceMetaDataApi;
    } catch {
      return null;
    }
  }

  return sourceMetaData;
};

export const getDataAuditWorkflowIdFromSourceMetaData = (
  sourceMetaData: DataAuditSourceMetaDataInput,
): string | null => {
  const parsed = parseDataAuditSourceMetaData(sourceMetaData);
  const workflowId = parsed?.sense_meta_data?.workflow_id || null;

  if (workflowId === undefined || workflowId === null || workflowId === '') {
    return null;
  }

  return String(workflowId);
};
